import { render, staticRenderFns } from "./RelatedImage.vue?vue&type=template&id=42b7c471"
import script from "./RelatedImage.vue?vue&type=script&lang=js"
export * from "./RelatedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports